(function () {
    "use strict";

    angular
        .module("app")
        .directive("cuttingPatternSearchHelp", ["SearchFactory", cuttingPatternSearchHelp]);

    function cuttingPatternSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.cuttingPatternName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.cuttingPatternName === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.cuttingPatternSearch(function (cuttingPattern) {
                        scope.cuttingPatternName = cuttingPattern ? cuttingPattern.CuttingPatternName : "";
                        scope.displayValue = scope.cuttingPatternName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.$watch("cuttingPatternName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.cuttingPatternName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { cuttingPatternName: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

